class TextScrambler {
    constructor(el, {
        duration = 1400,
        batchSize = 10,
        scrambleTime = 120
    } = {}) {
        this.el = el;
        this.duration = duration;
        this.batchSize = batchSize;
        this.scrambleTime = scrambleTime;
        this.chars = "abcdefghijklmnopqrstuvwxyz";
        this.update = this.update.bind(this);
    }

    setText(newText) {
        const oldText = this.el.innerText;
        const length = Math.max(oldText.length, newText.length);

        this.oldText = oldText.padEnd(length, " ");
        this.newText = newText.padEnd(length, " ");
        this.length = length;

        this.totalBatches = Math.ceil(length / this.batchSize);
        this.batchDuration = this.duration / this.totalBatches;

        this.startTime = performance.now();
        cancelAnimationFrame(this.frameRequest);
        this.frameRequest = requestAnimationFrame(this.update);
    }

    update(now) {
        const elapsed = now - this.startTime;
        const currentBatch = Math.floor(elapsed / this.batchDuration);
        const batchProgress = (elapsed % this.batchDuration) / this.batchDuration;

        let output = "";

        for (let i = 0; i < this.length; i++) {
            const batchIndex = Math.floor(i / this.batchSize);

            if (batchIndex < currentBatch) {
                // Already resolved
                output += this.newText[i];

            } else if (batchIndex === currentBatch && batchProgress < 0.7) {
                // Currently scrambling (first 70% of batch time)
                output += `<span class="scramble">${this.randomChar()}</span>`;

            } else if (batchIndex === currentBatch) {
                // Lock in at end of batch window
                output += this.newText[i];

            } else {
                // Not started yet
                output += this.oldText[i];
            }
        }

        this.el.innerHTML = output.trimEnd();

        if (elapsed < this.duration) {
            this.frameRequest = requestAnimationFrame(this.update);
        } else {
            this.el.innerText = this.newText.trimEnd();
        }
    }

    randomChar() {
        return this.chars[Math.floor(Math.random() * this.chars.length)];
    }
}

const HEX_SIZE = 110;
const PADDING = 5;
const HORIZONTAL_ORIENTATION = 0, VERTICAL_ORIENTATION = 1;
let current_orientation = null;
function apply_orientation_to_hex(orientation = VERTICAL_ORIENTATION) {
    const hex_corner = (centre, size, i, orientation = VERTICAL_ORIENTATION) => {
        var angle_deg = 60 * i - 30 * orientation;
        var angle_rad = Math.PI / 180 * angle_deg;
        return `${centre[0] + size * Math.cos(angle_rad)},${centre[1] + size * Math.sin(angle_rad)}`;
    };

    const hexShape = document.getElementById("hexShape");
    const points = [];
    for (let i = 0; i < 6; i++) {
        points.push(hex_corner([0, 0], HEX_SIZE, i, orientation));
    }
    hexShape.setAttribute("points", points.join(" "));
}

//offsets are defined in hex dimensions (1 = full dimension)
const configurations = {
    "default": {
        "orientation": HORIZONTAL_ORIENTATION,
        "start": [0.75, 1.1],
        "text": {
            width: "50%",
            height: "50%",
            top: "35%",
            left: "50%"
        },
        "offset": [
            { dx: 0, dy: 0, id: "Assurance" },
            { dx: 1, dy: 0.5, id: "Assessment" },
            { dx: 2, dy: 0, id: "Success" },
            { dx: 3, dy: -0.5, id: "Capability" },
            { dx: 2, dy: 1, id: "Employability" },
            { dx: 2, dy: 2, id: "Design" }
        ]
    },
    "Assurance": {
        "orientation": HORIZONTAL_ORIENTATION,
        "start": [1, 1],
        "text": {
            width: "50%",
            height: "50%",
            top: "10%",
            left: "50%"
        },
        "offset": [
            { dx: 0, dy: 0, id: "Assurance" },
            { dx: 1, dy: 0.5, id: "Assessment" },
            { dx: 0, dy: 2, id: "Success" },
            { dx: 2, dy: 1, id: "Capability" },
            { dx: 1, dy: 1.5, id: "Employability" },
            { dx: 2, dy: 2, id: "Design" }
        ]
    },
    "Assessment": {
        "orientation": HORIZONTAL_ORIENTATION,
        "start": [1.2, 1],
        "text": {
            width: "50%",
            height: "40%",
            top: "70%",
            left: "40%"
        },
        "offset": [
            { dx: 0, dy: 0, id: "Assurance" },
            { dx: 1, dy: 0.5, id: "Assessment" },
            { dx: 0, dy: 1, id: "Success" },
            { dx: 2, dy: 1, id: "Capability" },
            { dx: 1, dy: 1.5, id: "Employability" },
            { dx: 0, dy: 2, id: "Design" }
        ]
    },
    "Success": {
        "orientation": HORIZONTAL_ORIENTATION,
        "start": [1, 1],
        "text": {
            width: "50%",
            height: "50%",
            top: "65%",
            left: "38%"
        },
        "offset": [
            { dx: 0, dy: 0, id: "Assurance" },
            { dx: 1, dy: 0.5, id: "Assessment" },
            { dx: 2, dy: 0, id: "Success" },
            { dx: 3, dy: 0.5, id: "Capability" },
            { dx: 2, dy: 1, id: "Employability" },
            { dx: 1, dy: 1.5, id: "Design" }
        ]
    },
    "Capability": {
        "orientation": VERTICAL_ORIENTATION,
        "start": [1.2, 2],
        "text": {
            width: "50%",
            height: "50%",
            top: "10%",
            left: "40%"
        },
        "offset": [
            { dx: 0, dy: 0, id: "Assurance" },
            { dx: -0.5, dy: 1, id: "Assessment" },
            { dx: 0.5, dy: 1, id: "Success" },
            { dx: 1.5, dy: 1, id: "Capability" },
            { dx: 0, dy: 2, id: "Employability" },
            { dx: 1, dy: 2, id: "Design" }
        ]
    },
    "Employability": {
        "orientation": VERTICAL_ORIENTATION,
        "start": [1.2, 1],
        "text": {
            width: "50%",
            height: "80%",
            top: "30%",
            left: "50%"
        },
        "offset": [
            { dx: 0, dy: 0, id: "Assurance" },
            { dx: 1, dy: 0, id: "Assessment" },
            { dx: 0.5, dy: 1, id: "Success" },
            { dx: 0, dy: 2, id: "Capability" },
            { dx: -0.5, dy: 3, id: "Employability" },
            { dx: 0.5, dy: 3, id: "Design" }
        ]
    },
    "Design": {
        "orientation": VERTICAL_ORIENTATION,
        "start": [1.2, 1],
        "text": {
            width: "45%",
            height: "50%",
            top: "55%",
            left: "50%"
        },
        "offset": [
            { dx: 0, dy: 0, id: "Assurance" },
            { dx: 1, dy: 0, id: "Assessment" },
            { dx: -0.5, dy: 1, id: "Success" },
            { dx: 1.5, dy: 1, id: "Capability" },
            { dx: 0, dy: 2, id: "Employability" },
            { dx: 1, dy: 2, id: "Design" }
        ]
    }
};

const H_OFFSET = [];
H_OFFSET[HORIZONTAL_ORIENTATION] = (3 / 2) * HEX_SIZE + PADDING;
H_OFFSET[VERTICAL_ORIENTATION] = Math.sqrt(3) * HEX_SIZE + PADDING;

const V_OFFSET = [];
V_OFFSET[HORIZONTAL_ORIENTATION] = Math.sqrt(3) * HEX_SIZE + PADDING;
V_OFFSET[VERTICAL_ORIENTATION] = (3 / 2) * HEX_SIZE + PADDING;

let selected_configuration = null;
function apply_configuration(conf) {
    const c = configurations[conf];
    if (!c) {
        console.error("invalid configuration", conf);
        return;
    }
    console.log("configuration", conf, selected_configuration);

    // if reset button is needed, uncomment this
    // reset_hex_state()

    //if (conf === selected_configuration) return;   
    selected_configuration = conf;

    //if (c.orientation != current_orientation) {
    current_orientation = c.orientation;
    apply_orientation_to_hex(current_orientation);
    //}

    document.querySelector(".hex-svg").classList.remove("shimmer");
    setTimeout(() => {
        document.querySelector(".hex-svg").classList.add("shimmer");
    }, 100);

    const text = document.getElementById("hex-text-wrapper");
    text.style.width = c.text.width;
    text.style.maxHeight = c.text.height;
    text.style.top = c.text.top;
    text.style.left = c.text.left;

    const target = document.getElementById(`text-${conf}`);
    const wrapper = document.getElementById("hex-text-wrapper");
    if (target) {
        const resetButton = document.getElementById("hex-reset-button");
        if(resetButton) resetButton.style.display = "inline-block";
        document.getElementById("hex-text-master-default-content").style.width = 0;

        if (!wrapper.scramblerHeading) {
            wrapper.scramblerHeading = new TextScrambler(document.getElementById("hex-text-master-heading"), { duration: 800, batchSize: 1 });
            wrapper.scramblerParagraph = new TextScrambler(document.getElementById("hex-text-master-content"), { duration: 900, batchSize: 8 });
        }

        const targetHeading = target.querySelector("h3");
        wrapper.scramblerHeading.setText(targetHeading?.innerText || "");
        const targetPara = target.querySelector("div");
        wrapper.scramblerParagraph.setText(targetPara?.innerText || "");
        document.getElementById("hex-text-master-heading").style.display = "inline";

        const currentImg = document.getElementById("hex-text-master-img");
        const nextImg = document.getElementById("hex-text-master-img-old");

        function crossFadeTo(newSrc) {
            if (currentImg.src.endsWith(newSrc)) return;
            nextImg.src = newSrc;
            nextImg.style.opacity = 1;
            currentImg.style.opacity = 0;
            setTimeout(() => {
                currentImg.src = newSrc;
                currentImg.style.opacity = 1;
                nextImg.style.opacity = 0;
            }, 1000);
        }
        const targetImg = target.querySelector("img");

        if (targetImg) {
            document.querySelector(".hex-text-master-icon").style.display = "inline-block";
            crossFadeTo(targetImg.getAttribute("src"));
        } else {
            document.querySelector(".hex-text-master-icon").style.display = "none";
        }
        const targetLink = target.querySelector("a");
        if (targetLink) {
            document.getElementById("hex-text-master-link").style.display = "inline-block";
            document.getElementById("hex-text-master-link").setAttribute("href", targetLink.getAttribute("href"));
        } else {
            document.getElementById("hex-text-master-link").style.display = "none";
        }
    } else {
        const resetButton = document.getElementById("hex-reset-button");
        if (resetButton) resetButton.style.display = "none";
    }

    const get_hex = (id) => document.getElementById(`hex-${id}`);
    const sx = c.start[0] * H_OFFSET[current_orientation], sy = c.start[1] * V_OFFSET[current_orientation];
    c.offset.forEach(o => {
        const x = sx + H_OFFSET[current_orientation] * o.dx, y = sy + V_OFFSET[current_orientation] * o.dy;
        const hex = get_hex(o.id);
        hex.setAttribute("transform", `translate(${x}, ${y})`);
        if (conf == o.id) {
            hex.setAttribute("aria-expanded", "true");
        } else {
            hex.setAttribute("aria-expanded", "false");
        }
        hex.classList.toggle("hex-active", conf == o.id);
    });
}

function reset_hex_state() {  
    // function to reset the state of the hexes
    document.getElementById("hex-text-master-default-content").style.width = "110%";
    document.getElementById("hex-text-master-link").style.display = "none";
    document.querySelector(".hex-text-master-icon").style.display = "none";

    document.getElementById("hex-text-master-content").textContent = "";
    document.getElementById("hex-text-master-heading").textContent = "";
    document.getElementById("hex-text-master-heading").style.display = "none";

    // Reset image
    const currentImg = document.getElementById("hex-text-master-img");
    const nextImg = document.getElementById("hex-text-master-img-old");
    currentImg.style.opacity = 1;
    nextImg.style.opacity = 0;

    const resetButton = document.getElementById("hex-reset-button");
    if (resetButton) resetButton.style.display = "none";

    // Remove active hex states
    document.querySelectorAll(".hex-active")
        .forEach(h => h.classList.remove("hex-active"));
}

function initHex() {
    apply_configuration("default");

    document.querySelectorAll(".hex-button").forEach(hexButton =>
        hexButton.addEventListener("click", (btn => e => {
            e.preventDefault();
            //document.getElementById("hex-text-wrapper").scrollIntoView({behavior: 'smooth'});
            apply_configuration(btn.dataset.id);
        })(hexButton))
    );
    const resetButton = document.getElementById("hex-reset-button");
    if (resetButton) resetButton.addEventListener("click", function () {
        reset_hex_state();
        apply_configuration("default");
    });
}

export default initHex;